import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/52_card_back_astronaut/52_card_back_astronaut"
 * Contains 1 texture(s)
 */
export class CardsBacks52CardBackAstronautAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/52_card_back_astronaut/52_card_back_astronaut';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '52_astronaut.png'
    ] as const;
}
